import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpQuestionMarkComponent } from './help-question-mark.component';

@NgModule({
  declarations: [HelpQuestionMarkComponent],
  imports: [
    CommonModule
  ],
  exports: [HelpQuestionMarkComponent]
})
export class HelpQuestionMarkModule { }
